import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';

import {Icon} from 'front-onceforall-core';

import HelpMenu from './helpMenu';
import UserMenu from './userMenu';
import AccessPandaButton from './AccessPandaButton';
import AccessVitrineButton from './AccessVitrineButton';
import AccessBdrButton from './AccessBdrButton';
import appConfig from '../../../../config';
import {pathResolver} from '../../../utils/basePathHelper';

const menuIconContainerStyle = {
  background: 'rgba(245, 245, 245, 1)',
  padding: '10px',
  borderRadius: '10px',
  height: '40px',
  width: '40px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const GlobalHeaderView = props => {
  const appLinks = appConfig.isMicrofront ?
    <><AccessBdrButton/><AccessVitrineButton/></> :
    <><AccessPandaButton/><AccessVitrineButton/><AccessBdrButton/></>;

  return (
    <>
      <div className="global-bar">
        <div className='flex-container column'>
          <button
            data-id="button-home"
            type="button"
            className="button-square"
            onClick={props.onLogoClick}
            title={I18n.t(props.isGoBack ? 'action.back' : 'menu.home')}
          >
            {appConfig.isMicrofront ? <div style={menuIconContainerStyle}>
              <img
                className="home-button-icon"
                src={`${pathResolver('resources/img/alg.png')}`}
                alt="alg logo home"
                width='28'
              />
            </div> : <Icon icon={props.isGoBack ? 'go-back' : 'home'}/>
            }
          </button>
          {appLinks}
        </div>
        <div className="flex-container column">
          {props.newsUrl &&
        <button
          type="button"
          data-id="news"
          className="button-square"
          onClick={() => window.open(props.newsUrl)}
          title={I18n.t('menu.news')}
        >
          <Icon icon="newspaper"/>
        </button>
          }
          <UserMenu/>
        </div>
      </div>
      <HelpMenu/>
    </>
  );
};

GlobalHeaderView.propTypes = {
  onLogoClick: PropTypes.func.isRequired,
  isGoBack: PropTypes.bool,
  newsUrl: PropTypes.string
};

export default GlobalHeaderView;
